module.exports = __webpack_public_path__ + "media/images/photos/c2-acc38d26631d7c7590ca8bc5f12a003b.jpg";